import type { Request, Response } from 'tradera-backend/http/types/http';
import { isServer } from 'tradera/utils/nextjs';

type WebapiClient = {
    get: (
        req: Request,
        res: Response,
        path: string
    ) => Promise<{ json: () => string }>;
};

// Because @tradera-internal/infrastructure-logging
// used in webapiClient does not work in frontend.
const webapiClientModulePromise = (async () =>
    isServer
        ? import('tradera-backend/http/webapi-client')
        : Promise.resolve({ webapiClient: null }))();

const isWebapiClient = (client: unknown): client is WebapiClient =>
    client !== null && typeof client === 'object' && 'get' in client;

export const serverWebApiBaseQuery = async (
    req: Request,
    res: Response,
    pathOrConfig: string | object
) => {
    const webapiClientModule = await webapiClientModulePromise;
    const webapiClient = webapiClientModule.webapiClient;
    if (!isWebapiClient(webapiClient)) {
        throw new Error('webapiClient is not a WebapiClient');
    }
    if (typeof pathOrConfig !== 'string') {
        throw new Error(
            'Handling config is not implemented. Would be used for POST requests.'
        );
    }
    const response = await webapiClient.get(req, res, pathOrConfig);
    const data = await response.json();
    return { data };
};
